import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view
    const trackPageView = async () => {
      try {
        const token = localStorage.getItem('moviebot_token');
        await fetch(`${API_URL}/api/analytics/page-view`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
          },
          body: JSON.stringify({
            page: location.pathname,
            referrer: document.referrer || null
          })
        });
      } catch (error) {
        // Silent fail - analytics shouldn't break the app
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackPageView();
  }, [location.pathname]);
};

export default usePageTracking;
